import api from './axios';

// 가맹문의/본부지원 신청서의 "1차/2차 희망지역" 드롭다운용. WWW 백엔드가 BR_MST/FR_MST와
// 동일한 CODE_MST(CD_GROUP=REGION) 데이터를 그대로 읽기 전용으로 노출하는 공개 API.
export async function getSidoList() {
  const { data } = await api.get('/regions/sido');
  return data.data; // [{ cd, cdNm }]
}

export async function getSggList(sidoCd) {
  const { data } = await api.get('/regions/sgg', { params: { sidoCd } });
  return data.data; // [{ cd, cdNm }]
}
